/**
 * What every scene of the course shares: the pacing of its landings, and the
 * keys of the actions a scene takes on its own initiative.
 *
 * Each block keeps its own scene, and they all play on the same rhythm — the
 * Copilote types, the bubble lands, the card follows. The values live here so
 * that rhythm reads as one, and so changing it changes it everywhere at once.
 */

/**
 * How long the Copilote "types" before a bubble lands.
 */
export const TYPING_MS = 900;

/**
 * The beat between two landings: a bubble and its card, a bubble and its
 * quick replies, two steps of a reveal.
 */
export const BEAT_MS = 320;

/**
 * The minimum time a card of work in progress stays up — the scan of the
 * collection, the analysis of the alerts — even when the answer comes back
 * sooner: work that flashes past reads as nothing having been looked at.
 */
export const WORK_FLOOR_MS = 2000;

/**
 * The action asking the server to draft with the AI: the conclusion of a
 * closing scene, the table of the interventions.
 */
export const ACTION_DRAFT = 'draft';
